export enum TagMarginType {
  success = 'alocated',
  alert = 'failed',
  info = 'requested'
}
